import { useState } from 'react'
import { Field, TInp, PrimaryBtn } from './ui.jsx'
import { USERS } from '../../data/seed.js'

const LOGIN_STYLE=`.login-logo-icon{font-size:28px!important;display:inline-block!important}.login-logo-title{font-size:20px!important;font-weight:700!important;font-family:Arial,sans-serif!important;display:block!important}.login-logo-sub{font-size:9px!important;font-family:'Courier New',monospace!important;display:block!important;letter-spacing:4px!important}`;

function LoginScreen({onLogin,dark,toggleTheme}){
  const [email,setEmail]=useState("");
  const [pass,setPass]=useState("");
  const [err,setErr]=useState("");
  const [load,setLoad]=useState(false);
  const go=()=>{
    setLoad(true);
    setTimeout(()=>{
      const ENV_PASSWORDS={
        "opl1@croma.com.br":import.meta.env.VITE_OPL1_PASSWORD,
        "opl2@croma.com.br":import.meta.env.VITE_OPL2_PASSWORD,
      };
      const u=USERS.find(u=>{
        if(u.email!==email)return false;
        const envPwd=ENV_PASSWORDS[u.email];
        return envPwd?pass===envPwd:pass===u.password;
      });
      if(u)onLogin(u);else{setErr("Credenciais invalidas.");setLoad(false);}
    },500);
  };
  return(
    <><style>{LOGIN_STYLE}</style>
      <div style={{position:"fixed",inset:0,display:"flex",alignItems:"center",justifyContent:"center",background:"var(--bg)",padding:"16px",paddingTop:"calc(16px + env(safe-area-inset-top,0px))"}}>
        <button onClick={toggleTheme} style={{position:"absolute",top:"calc(16px + env(safe-area-inset-top,0px))",right:16,background:"none",border:"1px solid var(--border2)",color:"var(--text3)",padding:"6px 10px",fontSize:9,letterSpacing:2,cursor:"pointer",borderRadius:2}}>
          {dark?"☀ CLARO":"● ESCURO"}
        </button>
        <div style={{background:"var(--bg2)",border:"1px solid var(--border2)",padding:"36px 28px",width:"100%",maxWidth:380,borderRadius:2}}>
          <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:28}}>
            <span className="login-logo-icon" style={{color:"#ffa502"}}>▣</span>
            <div>
              <div className="login-logo-title" style={{color:"var(--text)",letterSpacing:4,lineHeight:1.1}}>ESTOQUE<span style={{color:"#ffa502"}}>OS</span></div>
              <div className="login-logo-sub" style={{color:"var(--text4)",marginTop:2}}>CROMA TECNOLOGIA</div>
            </div>
          </div>
          <Field label="E-MAIL"><TInp value={email} onChange={setEmail} type="email" placeholder="usuario@croma.com.br" onEnter={go}/></Field>
          <Field label="SENHA"><TInp value={pass} onChange={setPass} type="password" placeholder="••••••••" onEnter={go}/></Field>
          {err&&<p style={{color:"#ff4757",fontSize:11,margin:"-4px 0 10px",letterSpacing:1}}>{err}</p>}
          <PrimaryBtn onClick={go} style={{width:"100%",opacity:load?0.6:1,marginTop:6,padding:"13px 20px"}}>{load?"VERIFICANDO...":"ENTRAR"}</PrimaryBtn>
        </div>
      </div>
    </>
  );
}

export default LoginScreen